export default "__VITE_ASSET__CdVDggIc__"